import * as React from 'react';
import { IOptionIcon } from '../../../../common/ui/interfaces/selectors';
import { Divider, IconButton, Menu, MenuItem } from '@mui/material';
import { ReactComponent as EditIcon } from '../../../../assets/images/edit.svg';
import styles from './styles.module.scss';
import {
  MedicalDisontinuance,
  ReturnToWork,
} from '../../../../common/document/ui/documents';
import { DocumentTypeEnum } from '../../../../common/document/enums/document-type.enum';
import {
  DIALOG_TYPES,
  useGlobalDialogContext,
} from '../../../../App/components/Layouts/Dashboard/dialog/GlobalDialog';

const listOfDocumentTypes = [MedicalDisontinuance, ReturnToWork];

interface IProps {
  documentId: string;
  currentDocument: {
    name: string;
    documentType: DocumentTypeEnum;
  };
}

export const EditDocumentTypeMenu = ({
  documentId,
  currentDocument,
}: IProps) => {
  const { showDialog } = useGlobalDialogContext();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (item: IOptionIcon) => {
    switch (item.value) {
      case MedicalDisontinuance.value:
        showDialog(DIALOG_TYPES.CONFIRM_EDIT_DOCUMENT_TYPE_GLOBAL_DIALOG, {
          documentId,
          fromDocument: currentDocument,
          toDocument: {
            name: MedicalDisontinuance.label,
            documentType: MedicalDisontinuance.value,
          },
        });
        break;
      case ReturnToWork.value:
        showDialog(DIALOG_TYPES.CONFIRM_EDIT_DOCUMENT_TYPE_GLOBAL_DIALOG, {
          documentId,
          fromDocument: currentDocument,
          toDocument: {
            name: ReturnToWork.label,
            documentType: ReturnToWork.value,
          },
        });
        break;
    }
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        aria-label="edit"
        id="edit-positioned-button"
        aria-controls={open ? 'edit-positioned-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
      >
        <EditIcon />
      </IconButton>
      <Menu
        id="edit-positioned-menu"
        aria-labelledby="edit-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            '&': {
              border: '1px solid #D0D3D6',
              boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.15)',
              borderRadius: '1px',
            },
            '& ul': {
              padding: 0,
              margin: 0,
            },
            '& hr': {
              margin: '-4px 4px 2px',
            },
          },
        }}
      >
        <MenuItem classes={{ root: styles.menuTitle }}>
          <b>Change Document Type</b>
        </MenuItem>
        <Divider />
        {listOfDocumentTypes.map((item) => (
          <MenuItem
            key={item.value}
            className={styles.menuTitle}
            onClick={() => {
              handleSelect(item);
            }}
            disabled={
              currentDocument?.documentType &&
              currentDocument.documentType.toString() === item.value.toString()
            }
          >
            <span className={styles.title}>{item.label}</span>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};
